import {BaseModel} from '../base/BaseModel';

/**
 * @class UserSettingModel
 * @extends BaseModel
 */
export class UserSettingModel extends BaseModel {

    get idAttribute () {

        return 'uuid';
    }

    initialize () {

        this.microservice = 'users';
        this.resource = 'settings';
    }

    defaults () {

        return {
            name: '',
            value: '',
            scope: ''
        };
    }

    toJSON () {

        let obj = _.clone(this.attributes);

        delete obj.lastUpdated;

        return obj;
    }
}



// WEBPACK FOOTER //
// ./shared/model/users/UserSettingModel.js